var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.showDuplicateViewModalPopUp()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "copy" } })],
                1
              ),
              _c(
                "w-toolbar-item",
                {
                  attrs: { disabled: _vm.saveDisabled },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-padding": "" } },
        [
          _c(
            "w-breadcrumb",
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.currentTab,
                  callback: function ($$v) {
                    _vm.currentTab = $$v
                  },
                  expression: "currentTab",
                },
              }),
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      staticClass: "mr",
                      attrs: { icon: "copy" },
                      on: {
                        click: function ($event) {
                          return _vm.showDuplicateViewModalPopUp()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.duplicate")) + " ")]
                  )
                : _vm._e(),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "check", disabled: _vm.saveDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$t("common.settings"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12", md: "6" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          label: _vm.$ct("name"),
                                          fancy: "",
                                          "has-error": _vm.showNoViewNameError,
                                        },
                                        on: {
                                          blur: function ($event) {
                                            _vm.nameFieldWasFocused = true
                                          },
                                        },
                                        model: {
                                          value: _vm.view.Name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.view, "Name", $$v)
                                          },
                                          expression: "view.Name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm.metaDataEditComponent
                                ? _c(_vm.metaDataEditComponent, {
                                    tag: "component",
                                    attrs: { view: _vm.view },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "fast-fade", mode: "out-in" } },
                [
                  _vm.currentTab == 0
                    ? _c("app-view-columns", { attrs: { view: _vm.view } })
                    : _vm.currentTab == 1
                    ? _c("app-view-filters", { attrs: { view: _vm.view } })
                    : _vm.currentTab == 2
                    ? _c("app-totals", { attrs: { view: _vm.view } })
                    : _vm.currentTab == 3
                    ? _c("app-highlights", { attrs: { view: _vm.view } })
                    : _vm.currentTab == 4
                    ? _c("app-view-sidebar", { attrs: { view: _vm.view } })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showDuplicateViewModal,
            callback: function ($$v) {
              _vm.showDuplicateViewModal = $$v
            },
            expression: "showDuplicateViewModal",
          },
        },
        [
          _vm.showDuplicateViewModal
            ? _c("app-duplicate-view-modal", {
                attrs: { view: _vm.view },
                on: {
                  close: function ($event) {
                    _vm.showDuplicateViewModal = false
                  },
                  duplicateView: function ($event) {
                    return _vm.duplicateView($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }